import { AxiosInstance } from 'axios';
import authHeader from './auth_header';
import axiosInstance from "./axios_instance";

const ApiPath = "/api/orders";

class OrderService {
    private instance: AxiosInstance;
    private readonly navigate: any;

    constructor(navigate: any) {
        this.instance = axiosInstance(navigate);
        this.navigate = navigate
    }

    async order(data: any) {
        const headers = authHeader(this.navigate);
        return await this.instance.post(ApiPath, data, { headers });
    }

    async inquiry(params: any) {
        const headers = authHeader(this.navigate);
        return await this.instance.get(ApiPath, { headers, params });
    }

    async inquiryLatestAddresses() {
        const headers = authHeader(this.navigate);
        return await this.instance.get(ApiPath + '/latest_addresses', { headers });
    }

    async inquiryTodayCount() {
        const headers = authHeader(this.navigate);
        return await this.instance.get(ApiPath + '/today', { headers });
    }

    async summary(params: any) {
        const headers = authHeader(this.navigate);
        return await this.instance.get(ApiPath + '/summary', { headers, params });
    }

    async estimate(params: any) {
        const headers = authHeader(this.navigate);
        return await this.instance.get(ApiPath + '/estimate', { headers, params });
    }

    async downloadReceipt(key: string, index: number) {
        const headers = authHeader(this.navigate);
        index = index + 1;
        return await this.instance.get("/api/receipts/" + key + "/download/" + index, {headers, responseType: "blob"});
    }
}

export default OrderService;